<template>
  <div>
    <div class="home-slider">
      <div class="home-lead">
        <div class="df-logo-initial mg-b-15"><p>vet</p></div>
        <p class="home-text">Малын эм, бэлдмэлийн бүртгэлийн цахим систем</p>

        <h6 class="home-headline">
          Малын амьтны <span>эм, тэжээлийн нэмэлтийн</span> бүртгэлийн нэгдсэн
          мэдээллийн <span>сан</span>.
        </h6>

        <div class="d-flex wd-lg-350">
          <a
            @click="$router.push({ name: 'vetLandingMeds' })"
            role="button"
            class="btn btn-brand-01 btn-uppercase flex-fill text-white"
            >Бүртгэлтэй эм бэлдмэлүүд</a
          >
          <a
            @click="$router.push({ name: 'vetLandingLics' })"
            role="button"
            class="btn btn-success btn-uppercase flex-fill text-white mg-l-10"
            >Тусгай зөвшөөрөлтэй аж ахуйн нэгж</a
          >
        </div>

        <div class="d-flex tx-20 mg-t-40">
          <div class="tx-purple"><i class="fa fa-book-medical"></i></div>
          <div class="tx-orange pd-l-10">
            <i class="fa fa-laptop-medical"></i>
          </div>
          <div class="tx-primary pd-l-10"><i class="fa fa-medkit"></i></div>
          <div class="tx-pink pd-l-10"><i class="fa fa-heartbeat"></i></div>
          <div class="tx-warning pd-l-10">
            <i class="fa fa-truck-monster"></i>
          </div>
          <div class="tx-danger pd-l-10"><i class="fa fa-bullhorn"></i></div>
          <div class="tx-danger pd-l-10">
            <i class="fa fa-clipboard-check"></i>
          </div>
          <div class="bd-l mg-l-10 mg-sm-l-20 pd-l-10 pd-sm-l-20"></div>
          <div
            class="tx-color-03"
            data-toggle="tooltip"
            data-title="Ongoing development"
          >
            <i class="fa fa-smile"></i>
          </div>
          <div
            class="tx-color-03 pd-l-10"
            data-toggle="tooltip"
            data-title="Coming soon"
          >
            <i class="fa fa-laugh"></i>
          </div>
          <div
            class="tx-color-03 pd-l-10"
            data-toggle="tooltip"
            data-title="Coming soon"
          >
            <i class="fa fa-shield-alt"></i>
          </div>
        </div>

        <div class="tx-12 mg-t-40">
          <a class="link-03"
            >Гарын<span class="d-none d-sm-inline"> авлага</span
            ><span class="d-sm-none"></span
          ></a>
          <a class="link-03 mg-l-10 mg-sm-l-20">Шинэчлэл</a>
          <a class="link-03 mg-l-10 mg-sm-l-20">Үйлчилгээний нөхцөл</a>
        </div>
      </div>
      <div class="home-slider-img">
        <div><img src="assets/img/home-1.png" alt="" /></div>
        <div><img src="assets/img/home-2.png" alt="" /></div>
        <div><img src="assets/img/home-2.png" alt="" /></div>
      </div>
      <div class="home-slider-bg-one"></div>
    </div>
    <!-- home-slider -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    require("@/assets/scss/pages/landing.scss");
  },
  methods: {}
};
</script>
